<template>
  <footer class="footer">
    <div class="wrap footer__grid">
      <div>
        <router-link :to="localePath('/')" class="footer__logo" aria-label="牧色安全 Musesec"><BrandLogo large /></router-link>
        <p class="footer__tag">{{ c.footer.tagline }}</p>
      </div>
      <div>
        <p class="footer__h">{{ c.footer.cols[0].title }}</p>
        <router-link v-for="s in SERVICES" :key="s.slug" :to="localePath('/services/' + s.slug + '/')">{{ s[lang].nav }}</router-link>
      </div>
      <div v-for="col in c.footer.cols.slice(1)" :key="col.title">
        <p class="footer__h">{{ col.title }}</p>
        <router-link v-for="l in col.links" :key="l.label" :to="l.path ? localePath(l.path) : localePath('/') + '#' + l.id">{{ l.label }}</router-link>
      </div>
      <div>
        <p class="footer__h">{{ c.footer.channels }}</p>
        <a :href="TWITTER_URL" target="_blank" rel="noopener">X / Twitter</a>
        <a :href="TELEGRAM_URL" target="_blank" rel="noopener">Telegram</a>
        <a :href="'mailto:' + CONTACT_EMAIL">{{ CONTACT_EMAIL }}</a>
        <router-link :to="localePath(stripLang($route.path), lang === 'zh' ? 'en' : 'zh')" @click="saveLangPref(lang === 'zh' ? 'en' : 'zh')">
          {{ lang === 'zh' ? 'English' : '中文' }}
        </router-link>
      </div>
    </div>
    <div class="wrap footer__bar">
      <span>© {{ year }} {{ c.footer.rights }}</span>
      <span class="footer__status"><span class="live-dot"></span>{{ c.footer.status }}</span>
    </div>
  </footer>
</template>

<script setup>
import { content as c, lang, localePath, stripLang, saveLangPref, CONTACT_EMAIL, TWITTER_URL, TELEGRAM_URL } from '@/i18n'
import { SERVICES } from '@/content-pages.mjs'
import BrandLogo from './BrandLogo.vue'
const year = new Date().getFullYear()
</script>

<style scoped>
.footer { background: var(--ink); border-top: 1px solid var(--ink-line); padding-top: 72px; }
.footer__grid { display: grid; grid-template-columns: 1.4fr 1.2fr 1fr 1fr 1fr; gap: 32px; padding-bottom: 56px; }
.footer__grid a.footer__logo { display: inline-flex; margin-bottom: 0; }
.footer__tag { margin-top: 18px; font-family: var(--font-mono); font-size: 12px; letter-spacing: .16em; color: var(--ink-muted); }
.footer__h { font-family: var(--font-mono); font-size: 11px; letter-spacing: .2em; color: var(--ink-text); margin-bottom: 18px; }
.footer__grid a { display: block; color: var(--ink-muted); font-size: 14px; margin-bottom: 12px; }
.footer__grid a:hover { color: var(--accent); }
.footer__bar { display: flex; flex-wrap: wrap; gap: 16px 28px; align-items: center; padding-top: 24px; padding-bottom: 28px; border-top: 1px solid var(--ink-line); font-size: 13px; color: var(--ink-dim); }
.footer__status { display: flex; align-items: center; gap: 10px; font-family: var(--font-mono); font-size: 11px; letter-spacing: .16em; }
@media (max-width: 1080px) {
  .footer__grid { grid-template-columns: 1fr 1fr 1fr; }
  .footer__grid > div:first-child { grid-column: 1 / -1; }
}
@media (max-width: 600px) {
  .footer__grid { grid-template-columns: 1fr 1fr; }
  }
</style>
